import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

import { getSuggestedTags } from '../../api/suggested';

export const fetchSuggestedTags = createAsyncThunk(
  'suggested/fetchSuggestedTags',
  async (args, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const response = await getSuggestedTags(args, {
        cancelToken: source.token,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
  {
    condition: (thunkArg, { getState }) => {
      const { loading } = getState().suggested;

      return loading !== 'pending';
    },
  },
);

const initialState = {
  tags: [],
  type: undefined,
  offset: 0,
  loading: 'idle',
  currentRequestId: undefined,
  error: null,
};

export const SuggestedSlice = createSlice({
  name: 'suggested',
  initialState,
  reducers: {
    resetSuggestedTags: () => initialState,
  },
  extraReducers: {
    [fetchSuggestedTags.pending]: (state, { meta }) => {
      if (state.loading === 'idle') {
        state.type = undefined;
        state.loading = 'pending';
        state.currentRequestId = meta.requestId;
      }
    },
    [fetchSuggestedTags.fulfilled]: (state, { meta, payload }) => {
      const { requestId, arg } = meta;

      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        if (arg.offset === 0) {
          state.offset = arg.count;
          state.tags = [...payload];
        } else {
          state.offset += arg.count;
          state.tags = [...state.tags, ...payload];
        }

        state.type = arg.type;
        state.loading = 'idle';
        state.currentRequestId = undefined;
      }
    },
    [fetchSuggestedTags.rejected]: (state, { meta, error }) => {
      if (
        state.loading === 'pending' &&
        state.currentRequestId === meta.requestId
      ) {
        state.type = undefined;
        state.loading = 'idle';
        state.error = error.message;
        state.currentRequestId = undefined;
      }
    },
  },
});

export const { resetSuggestedTags } = SuggestedSlice.actions;

export default SuggestedSlice.reducer;
